"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.success.completed': 'Onboarding zakończony pomyślnie! Twój asystent AI jest gotowy.',
    'onboarding.success.progress_saved': 'Postęp zapisany pomyślnie',
};
